<template>
  <div class="container">
    <div
      class="flex align-items-center justify-content-right font-black text-black border-round"
    >
      <InputText
        v-model="inputCode"
        type="text"
        @keypress.enter="getTrackingCode"
      />
      <p class="err-msg" v-if="isError">
        Tracking number requires at least 3 characters
      </p>
    </div>
    <div class="flex align-items-center justify-content-right w-8rem h-3rem">
      <base-button label="Track" @click="getTrackingCode" />
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.emitter.on("search", (evt) => {
      if(evt.eventContent.length < 3) {
        this.isError = true;
        return;
      }
      this.inputCode = evt.eventContent;

    });
  },
  data() {
    return {
      inputCode: "",
      isError: false,
    };
  },
  emits: ["get-tracking-code"],
  methods: {
    getTrackingCode() {
      if (!this.validateSearch()) {
        this.isError = true;
        return;
      }
      this.emitter.emit("search", { eventContent: this.inputCode });
      this.$emit("get-tracking-code", this.inputCode);
      this.isError = false;
      this.$router.push("/")
    },
    validateSearch() {
      return this.inputCode.length < 3 ? false : true
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  background-color: #e7eef1;
  height: 9.6rem;
  align-items: center;
  padding-left: 5rem;
  gap: 1rem;
}

.p-inputtext {
  width: 20rem;
  height: 4rem;
  font-size: 1.4rem;
}

.err-msg {
  color: #ff0033;
  position: absolute;
  top: 14.2rem;
  font-size: 1.2rem;
}
</style>
